import { render } from "./NewbornRecord.vue?vue&type=template&id=7a61f75a&scoped=true"
import script from "./NewbornRecord.vue?vue&type=script&lang=js"
export * from "./NewbornRecord.vue?vue&type=script&lang=js"

import "./NewbornRecord.vue?vue&type=style&index=0&id=7a61f75a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a61f75a"]])

export default __exports__